import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import numeral from 'numeral'
import moment from 'moment'

import { formatcoin, getDivisa } from '../../utils/helpers'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'
import BoxButton from '../Layout/BoxButton'

import { getParameterByName } from '../../actions/common'

import {
    displayModalCreateDocumento,
    updateInputs,
    addGarantia,
    createOrUpdateDocumento,
    previewDocumento,
    calculateIva
} from '../../actions/solicitudbi'


class ModalCreateDocumento extends Component {

    componentWillMount() {
        this.props.getParameterByName('ALMACEN')
        this.props.getParameterByName('TIPO_FORMAS_PAGO')
        this.props.getParameterByName('TOLERANCIA')
    }

	handleCloseModal = (e) => {

		const modal = document.getElementById('modalCreateDocumento')
		modal.classList.remove('fadeIn')
		modal.classList.add('fadeOut')

		const modalDialog = document.querySelector(`#modalCreateDocumento .modal-dialog`)
		modalDialog.classList.remove('zoomIn')
		modalDialog.classList.add('zoomOut')

		setTimeout(() => this.props.displayModalCreateDocumento(false, '', ''), 300)
    }

    getTotalSinIva = () => {
        return this.props.modalCreateDocumento.getIn(['data', 'detalles']).reduce((acum, detalle) => {
            acum += detalle.get('valor') * detalle.get('cantidad')
            return acum
        }, 0)
    }


    getTotalConIva = () => {
        return this.props.modalCreateDocumento.getIn(['data', 'detalles']).reduce((acum, detalle) => {
            acum += detalle.get('valor_con_iva') * detalle.get('cantidad')
            return acum
        }, 0)
    }

	render() {

        const { modalCreateDocumento, enums, documento_origen, almacenes, tipo_formas_pago, divisas } = this.props

		if (!modalCreateDocumento.get('show')) {
			return null
        }

        const moneda = modalCreateDocumento.getIn(['data', 'cotizacion', 'moneda'])
        const divisa = getDivisa(divisas, moneda)

        const tipoDocumento = modalCreateDocumento.getIn(['data','tipo']) ? modalCreateDocumento.getIn(['data','tipo']) : 0
        const contratoanual = modalCreateDocumento.get('contratoanual')

        const allowedTypes = []
        const readOnly = (documento_origen != null)

        if (contratoanual) {
            allowedTypes.push(1)
        } else {
            allowedTypes.push(2,3)
            if (tipoDocumento == 4) allowedTypes.push(4)
        }

		return(
			<Modal id="modalCreateDocumento" show={ true } ZIndex={ 2000 } >

                <form id="form" onSubmit={ e => { e.preventDefault(); this.props.createOrUpdateDocumento() }} noValidate>

					<ModalHeader title={ modalCreateDocumento.get('title') } onClose={ (e) => this.handleCloseModal(e) } />

					<ModalButtonStrip>
                        <BoxButton name="eye" onClick={e => {e.preventDefault(); this.props.previewDocumento(modalCreateDocumento.getIn(['data', 'id']))}} disabled={ modalCreateDocumento.get('btnDisabled') } title="Visualizar" />
                        <BoxButton name="floppy-o" disabled={ modalCreateDocumento.get('btnDisabled') } title="Guardar" />
					</ModalButtonStrip>

					<ModalBody >
                        <div className="create-document" style={{ width: tipoDocumento === 4 ? '70vw':'80vw', height: tipoDocumento === 4 ? '55vh':'80vh' }}>
                            <div className="row">
                                <div className="col-md-3">
                                    <table className="table table-condensed table-bordered table-striped nowrap">
                                        <colgroup>
                                            <col style={{ width:'35%', color: '#333', fontWeight: 'bold' }} />
                                            <col style={{}}/>
                                        </colgroup>
                                        <tbody>
                                            <tr>
                                                <td>Tipo documento</td>
                                                <td>{ modalCreateDocumento.getIn(['data', 'tipo']) ? enums.documentos.tipos[modalCreateDocumento.getIn(['data', 'tipo'])].NOMBRE : 'PENDIENTE' }</td>
                                            </tr>
                                            <tr>
                                                <td>No. documento</td>
                                                <td>{ (modalCreateDocumento.getIn(['data', 'tipo']) ? enums.documentos.tipos[modalCreateDocumento.getIn(['data', 'tipo'])].PREFIJO : 'PENDIENTE') + (modalCreateDocumento.getIn(['data', 'consecutivo']) || '') }</td>
                                            </tr>
                                            <tr>
                                                <td>Proveedor</td>
                                                <td>{ modalCreateDocumento.getIn(['data', 'proveedore', 'nombre']) }</td>
                                            </tr>
                                            <tr>
                                                <td>Valor sin IVA</td>
                                                <td>{ formatcoin( (this.getTotalSinIva()), divisa.simbolo ) }</td>
                                            </tr>
                                            <tr>
                                                <td>Valor total</td>
                                                <td>{ formatcoin( (this.getTotalConIva()), divisa.simbolo ) }</td>
                                            </tr>
                                            <tr>
                                                <td rowSpan={ modalCreateDocumento.getIn(['data', 'detalles']).count() }>Bienes</td>
                                                <td>{ modalCreateDocumento.getIn(['data', 'detalles']).first().get('descripcion') }</td>
                                            </tr>
                                            {
                                                modalCreateDocumento.getIn(['data', 'detalles']).map((a, b) => {
                                                    if (b === 0) return null
                                                    return (
                                                        <tr key={ `tr0[${a.get('id')}]` }>
                                                            <td>{ a.get('descripcion') }</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="col-md-9">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">

                                                {
                                                    ((tipoDocumento == 1) || (tipoDocumento == 3)) ? (
                                                        <Fragment>
                                                        <label className="control-label">Fecha registro</label>
                                                        <input type="date" className="form-control input-sm" value={ moment().format('YYYY-MM-DD') || '' } disabled/>
                                                        </Fragment>
                                                    ) : (
                                                        <Fragment>
                                                        <label className="control-label">Fecha inicio</label>
                                                        <input type="date" className="form-control input-sm" value={ moment(modalCreateDocumento.getIn(['data','fecha_inicio'])).format('YYYY-MM-DD') || '' } onChange={ (e) => this.props.updateInputs(`modalCreateDocumento.data.fecha_inicio`, e.target.value) } disabled={ tipoDocumento == 4 } />
                                                        </Fragment>
                                                    )
                                                }

                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Fecha entrega</label>
                                                <input type="date" className="form-control input-sm" value={ moment(modalCreateDocumento.getIn(['data','fecha_entrega'])).format('YYYY-MM-DD') || '' } onChange={ (e) => this.props.updateInputs(`modalCreateDocumento.data.fecha_entrega`, e.target.value) } disabled={ tipoDocumento == 4 } />
                                            </div>
                                        </div>
                                        {
                                            modalCreateDocumento.getIn(['data', 'tipo']) != 4 && (

                                                <div className="col-md-6 hidden">
                                                    <div className="form-group">
                                                        <label>
                                                            <input style={{ marginTop: '-10px' }} type="checkbox" value={ modalCreateDocumento.get('contratoanual')  } onChange={ (e) => this.props.updateInputs(`modalCreateDocumento.contratoanual`, e.target.checked) } />
                                                            <span style={{ marginLeft: '5px' }}>Contrato anual</span>
                                                        </label>
                                                        <select className="form-control input-sm" value={ modalCreateDocumento.getIn(['data', 'documento_id']) || 0 } onChange={ (e) => { this.props.updateInputs(`modalCreateDocumento.data.documento_id`, Number(e.target.value)) } } disabled={ modalCreateDocumento.get('contratoanual') == false }>
                                                            <option value={ 0 } disabled>Seleccione un número de contrato</option>
                                                            {
                                                                modalCreateDocumento.get('contratosAnuales').map(a => {
                                                                    return (
                                                                        <option key={ `opt3[${a.get('id')}]` } value={ a.get('id') }>{ a.get('consecutivo') }</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                    { tipoDocumento != 4 && (<Fragment>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="control-label">Seleccione el tipo de documento</label>
                                                <select className="form-control input-sm" value={ tipoDocumento } onChange={ (e) => { this.props.updateInputs(`modalCreateDocumento.data.tipo`, e.target.value); this.props.updateInputs(`modalCreateDocumento.data.plantilla_id`, "") } } disabled ={readOnly} >
                                                    <option value={ 0 } disabled>Seleccione una opcion</option>
                                                    {
                                                        Object.keys(enums.documentos.tipos).map(a => {
                                                            if (allowedTypes.indexOf(Number(a)) != -1) {
                                                                return (
                                                                    <option key={ `opt1[${a}]` } value={ a }>{ enums.documentos.tipos[a].NOMBRE }</option>
                                                                )
                                                            }

                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="control-label">Seleccione la plantilla del documento</label>
                                                <select className="form-control input-sm" value={ modalCreateDocumento.getIn(['data', 'plantilla_id']) || -1 } onChange={ (e) => { this.props.updateInputs(`modalCreateDocumento.data.plantilla_id`, e.target.value) } } disabled={ Number(modalCreateDocumento.getIn(['data', 'tipo'])) === 0 }>
                                                    <option value={ -1 } disabled>Seleccione una opción</option>
                                                    {
                                                        modalCreateDocumento.get('plantillas').filter(a => a.get('tipo') === Number(modalCreateDocumento.getIn(['data', 'tipo']))).map(a => {
                                                            return (
                                                                <option key={ `opt1[${a.get('id')}]` } value={ a.get('id') }>{ a.get('nombre') }</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    </Fragment>) }
                                    <div className="row">
                                        <div className="col-md-12 form-group">
                                            <label className="control-label">Anticipo</label>
                                            <div className="col-md-12" style={{ padding: '5px 10px', border: '1px solid #eee', borderRadius: '3px' }}>
                                                <div className="col-md-2" style={{padding: "1px 2px"}}>
                                                    <div className="form-group">
                                                        <label className="control-label">% Anticipo</label>
                                                        <input type="text" className="form-control input-sm" value={modalCreateDocumento.getIn(['data', 'anticipo'])}
                                                            onChange={(e) => this.props.updateInputs(`modalCreateDocumento.data.anticipo`, e.target.value)}
                                                            disabled={modalCreateDocumento.getIn(['data', 'cotizacion', 'cotizado']) == 0} />
                                                    </div>
                                                </div>

                                                <div className="col-md-2" style={{padding: "1px 2px"}}>
                                                    <div className="form-group">
                                                        <label className="control-label">Valor</label>
                                                        <input type="text" className="form-control input-sm" value={ formatcoin( ((this.getTotalSinIva() * modalCreateDocumento.getIn(['data', 'anticipo'])) / 100), divisa.simbolo ) } disabled />
                                                    </div>
                                                </div>

                                                <div className="col-md-3" style={{padding: "1px 2px"}}>
                                                    <div className="form-group">
                                                        <label className="control-label">Fecha pago</label>
                                                        <input type="date" className="form-control input-sm" value={moment(modalCreateDocumento.getIn(['data', 'pago_anticipo'])).format('YYYY-MM-DD') || ''}
                                                            onChange={(e) => this.props.updateInputs(`modalCreateDocumento.data.pago_anticipo`, e.target.value)}
                                                            disabled={(modalCreateDocumento.getIn(['data', 'anticipo']) == 0) || modalCreateDocumento.getIn(['data', 'cotizacion', 'cotizado']) == 0} />
                                                    </div>
                                                </div>

                                                <div className="col-md-3" style={{padding: "1px 2px"}}>
                                                    <div className="form-group">
                                                        <label className="control-label">Forma de pago</label>
                                                        <select className="form-control input-sm" value={modalCreateDocumento.getIn(['data', 'forma_pago_anticipo']) || 0}
                                                            onChange={(e) => this.props.updateInputs(`modalCreateDocumento.data.forma_pago_anticipo`, e.target.value)}
                                                            disabled={(modalCreateDocumento.getIn(['data', 'anticipo']) == 0) || modalCreateDocumento.getIn(['data', 'cotizacion', 'cotizado']) == 0}>
                                                            <option value={0} disabled>Seleccione una forma de pago</option>
                                                            {
                                                                tipo_formas_pago && tipo_formas_pago.map((formaPago, iformaPago) => {
                                                                    return <option key={`opt[0][${iformaPago}]`} value={formaPago.get('NOMBRE')}>{formaPago.get('NOMBRE')}</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-md-2" style={{padding: "1px"}}>
                                                    <div className="form-group">
                                                        <label className="control-label">Días pagos del saldo</label>
                                                        <input type="text" className="form-control input-sm" value={modalCreateDocumento.getIn(['data', 'dias_pagos_saldo']) || ''}
                                                            onChange={(e) => this.props.updateInputs(`modalCreateDocumento.data.dias_pagos_saldo`, e.target.value)} />
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>



                                    { tipoDocumento != 4 && (<Fragment>
                                    <div className="row">

                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="control-label">Seleccione las garantias</label>
                                                <div style={{ padding: '5px 10px', border: '1px solid #eee', borderRadius: '3px' }}>
                                                    <div className="row">
                                                    {
                                                        modalCreateDocumento.get('garantias').map((a, b) => {
                                                            return (
                                                                <div key={ `div1[${a.get('id')}]` } className="col-md-12">
                                                                    <div className="checkbox" style={{ margin: '0' }}>
                                                                        <label>
                                                                            <input type="checkbox" checked={ modalCreateDocumento.getIn(['data','garantias']).filter(x => x.get('id') === a.get('id')).count() === 1 } onChange={ (e) => this.props.addGarantia(e.target.checked, b, a.get('id')) } disabled ={readOnly} />
                                                                            { a.get('nombre') }
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="control-label">IVA</label>

                                                <div style={{ padding: '5px 10px', border: '1px solid #eee', borderRadius: '3px' }}>

                                                    <table className="table table-condensed table-striped">
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ width: '55%' }}>Valor total del IVA</td>
                                                                <td style={{ width: '0%', display: 'none' }}><input type="number" className="form-control input-sm" value={modalCreateDocumento.getIn(['data', 'iva'])} onChange={(e) => this.props.updateInputs(`modalCreateDocumento.data.iva`, e.target.value)} disabled={readOnly} /></td>
                                                                <td style={{ width: '45%' }}>
                                                                    <input type="text" className="form-control input-sm" style={{display:'inline-block', width: 'Calc(100% - 30px)'}} value={modalCreateDocumento.getIn(['data', 'iva_value'])} onChange={(e) => this.props.updateInputs(`modalCreateDocumento.data.iva_value`, e.target.value)} disabled={readOnly} />
                                                                    <BoxButton name="retweet" onClick={e => {e.preventDefault(); this.props.calculateIva()}} disabled={readOnly} title="Calcular IVA" size='12' />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ width: '35%' }}>Total</td>
                                                                <td style={{ width: '65%', textAlign: 'right' }} colSpan={2}>
                                                                    <strong>{ formatcoin( (modalCreateDocumento.getIn(['data', 'aiu_total'])), divisa.simbolo ) }</strong>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label className="control-label">Opciones adicionales</label>
                                                <div style={{ padding: '5px 10px', border: '1px solid #eee', borderRadius: '3px' }}>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="checkbox" style={{ margin: '0' }}>
                                                                <label>
                                                                    <input type="checkbox" checked={modalCreateDocumento.getIn(['data', 'entregas_parciales'])} onChange={(e) => this.props.updateInputs('modalCreateDocumento.data.entregas_parciales', e.target.checked)} disabled={readOnly} />
                                                                    Entregas parciales
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </Fragment>)}
                                    <div className="row">
                                        <div className="col-md-12">
                                            <label className="control-label">Opciones del documento</label>
                                            <div style={{ padding: '5px 10px', border: '1px solid #eee', borderRadius: '3px' }}>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label className="control-label">Almacén</label>
                                                            <select className="form-control input-sm" value={ (modalCreateDocumento.getIn(['data', 'almacen']) || 0) } onChange={(e) => this.props.updateInputs(`modalCreateDocumento.data.almacen`, e.target.value)}>
                                                                <option value={0} disabled>Seleccione un almacen</option>
                                                                {
                                                                    almacenes && almacenes.map((almacen, ialmacen) => {
                                                                        return <option key={`opt[0][${ialmacen}]`} value={almacen.get('ALMACEN')}>{almacen.get('ALMACEN')}</option>
                                                                    })
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label className="control-label">No. Cotización</label>
                                                            <input type="text" className="form-control input-sm" value={modalCreateDocumento.getIn(['data', 'numero_cotizacion']) || ''} onChange={(e) => this.props.updateInputs(`modalCreateDocumento.data.numero_cotizacion`, e.target.value)} />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label className="control-label">Fecha Cotización</label>
                                                            <input type="date" className="form-control input-sm" value={moment(modalCreateDocumento.getIn(['data', 'fecha_cotizacion'])).format('YYYY-MM-DD') || ''} onChange={(e) => this.props.updateInputs(`modalCreateDocumento.data.fecha_cotizacion`, e.target.value)} />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label className="control-label">Clausula %</label>
                                                            <input type="number" className="form-control input-sm" value={modalCreateDocumento.getIn(['data', 'clausula']) || ''} onChange={(e) => this.props.updateInputs(`modalCreateDocumento.data.clausula`, e.target.value)} />
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label className="control-label">Alcance y entregables de la Cotización</label>
                                                            <textarea type="text" className="form-control input-sm" rows={4} value={modalCreateDocumento.getIn(['data', 'alcance_entregables']) || ''}
                                                                onChange={(e) => this.props.updateInputs(`modalCreateDocumento.data.alcance_entregables`, e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label className="control-label">Garantías</label>
                                                            <textarea type="text" className="form-control input-sm" rows={4} value={modalCreateDocumento.getIn(['data', 'garantia_documento']) || ''}
                                                                onChange={(e) => this.props.updateInputs(`modalCreateDocumento.data.garantia_documento`, e.target.value)} />
                                                        </div>
                                                    </div>
                                                    {
                                                        modalCreateDocumento.getIn(['data', 'aprobacion', 'observaciones']) && (
                                                            <div className="col-md-12">
                                                                <div className="form-group">
                                                                    <label className="control-label">Observaciones del proveedor</label>
                                                                    <textarea type="text" className="form-control input-sm" rows={4} defaultValue={modalCreateDocumento.getIn(['data', 'aprobacion', 'observaciones']) || ''} disabled />
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
						    </div>
						</div>
					</ModalBody >
					<ModalFooter >
					</ModalFooter>
				</form>
			</Modal>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		modalCreateDocumento: state.solicitudBI.get('modalCreateDocumento'),
        enums: state.common.get('enums').toJS(),
        documento_origen: state.solicitudBI.getIn(['solicitud', 'documento_origen']),
        almacenes: state.common.getIn(['parametros', 'ALMACEN']),
        tipo_formas_pago: state.common.getIn(['parametros', 'TIPO_FORMAS_PAGO']),
        divisas: state.common.getIn(['parametros', 'DIVISAS'])
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		displayModalCreateDocumento: (show, title, mode) => dispatch(displayModalCreateDocumento(show, title, mode)),
		updateInputs: (path, value, immutable) => dispatch(updateInputs(path, value, immutable)),
        addGarantia: (checked, index, id) => dispatch(addGarantia(checked, index, id)),
        createOrUpdateDocumento: () => dispatch(createOrUpdateDocumento()),
        previewDocumento: (id) => dispatch(previewDocumento(id)),
        getParameterByName: (nombre) => dispatch(getParameterByName(nombre)),
        calculateIva: () => dispatch(calculateIva()),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalCreateDocumento)



// WEBPACK FOOTER //
// ./src/components/SolicitudBI/ModalCreateDocumento.jsx